import React, {useEffect, useState} from 'react';
import Container from '../../../../components/layout/container';
import '../../../../pages/business/misc/faq/faq.css';
import '../../../../pages/business/plan/pricing/component/faq/index.css';
import Parser from 'react-html-parser';
import _isEmpty from 'lodash/isEmpty';

export default function StrapiFaq({title, faqList}) {
  const [faqContent, setFqaContent] = useState([]);

  useEffect(() => {
    setFqaContent(faqList);
  }, [faqList]);

  const clickQuestion = id => {
    setFqaContent(content =>
      content.map(c => {
        if (c.id === id) {
          return {...c, isExpand: !c.isExpand};
        } else {
          return {...c, isExpand: false};
        }
      })
    );
  };
  if (_isEmpty(faqList)) return <div />;

  return (
    <div className="pf-pricing-smb-faq">
      <Container>
        <h2 className="pf-pricing-smb-faq-title">{title}</h2>
        <div className="pf-business-faq-list pf-pricing-smb-choose-plan-faq">
          <div className="faq-content">
            <div className="faq-content-items">
              {faqContent.map(c => (
                <div
                  key={c.id}
                  className={
                    c.isExpand
                      ? 'faq-content-item-group active'
                      : 'faq-content-item-group'
                  }
                >
                  <div
                    className="panel-heading"
                    onClick={() => clickQuestion(c.id)}
                  >
                    <div className="faq-content-title">
                      <h3 className="faq-content-title-text">{c.question}</h3>
                      <div className="faq-content-title-close">
                        {!c.isExpand && (
                          <img
                            src={require('../../../../assets/images/business/plan/up_arrow.svg')}
                            className="fa fa-chevron-down pf-pricing-smb-choose-plan-faq-content__icon"
                            alt=""
                          />
                        )}
                        {c.isExpand && (
                          <img
                            src={require('../../../../assets/images/business/plan/down_arrow.svg')}
                            className="fa fa-chevron-up pf-pricing-smb-choose-plan-faq-content__icon"
                            alt=""
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="panel-collapse content-collapse">
                    <div
                      className={
                        c.isExpand
                          ? 'panel-body content-collapse show'
                          : 'panel-body content-collapse'
                      }
                      style={{borderTop: c.isExpand && 'unset'}}
                    >
                      {Parser(c.answer)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
